import React from "react";
import SubBanner from "./components/SubBanner";
import LocationSection from "./components/LocationSection";

function Locations() {
  return (
    <>
      <SubBanner title="Locations" />
      <LocationSection />
      
    </>
  );
}

export default Locations;